// languages hold the available languages that a customer can choose between.
// Note that you cannot add a language here without having a file with the "iso" name (e.g. "sv.js" for Swedish) in
// src/filters/language.
const languages = [
  {
    iso: 'en',
    name: 'English'
  },
  {
    iso: 'sv',
    name: 'Svenska'
  }
]

export default {
  strict: true,

  state: {
    // These are heavily intertwined with the "translate"-filter. Don't add languages here that aren't translated.
    languages: languages,
    currLanguage: languages[1]
  },

  mutations: {
    SET_LANGUAGE (state, iso) {
      languages.forEach(function (lang) {
        if (lang.iso === iso) {
          state.currLanguage = lang

          // We want to break the loop, so this return is not useless.
          /* eslint-disable no-useless-return */
          return
        }
      })
    }
  },

  actions: {
    setLanguage ({ commit }, iso) {
      commit('SET_LANGUAGE', iso)
    }
  },

  getters: {
    getLanguages (state) { return state.languages },
    getCurrLanguage (state) { return state.currLanguage }
  }
}



// WEBPACK FOOTER //
// ./src/stores/language.js